<template>
    <div class="planningReport">
        <div class="content">
            <!-- <div class="mainBox">
                <div class="titleBox">
                    <p class="title">学生生涯测评报告</p>
                </div>
                <CareerReport :userType="userType"/>
            </div> -->
            <PlanReport :title="planReportTitle" :plan="plan" :version="version"></PlanReport>
        </div>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnBlue'" name="返回" ></Button>
<!--            <Button @handleClick="goSubmit" :type="'btnBlue'" :name="navList[navIndex].btnName" ></Button>-->
        </div>
    </div>
</template>
<script>
import CareerReport from '@/components/consultant/planningContent/CareerReport.vue'
import PlanReport from '@/components/consultant/planningContent/PlanReport.vue'
import Button from '@/components/Button.vue'
export default {
    name: "planningReport",
    components: {
        CareerReport,
        PlanReport,
        Button
    },
    data() {
        return {
            userType: 2,
            planReportTitle: '学业发展规划',
            id: this.$route.query.id,
            plan: {},
            version:'',
        }
    },
    methods: {
        getPlanById(){
            let id = this.id;
            this.$ajax.post(this.G_acapi + this.ports.parent.student.planningContent.getPlanByIdByParent,{
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                console.log(res)
                let data = res.data;
                if (data.code == 2000) {
                    this.plan = res.data.data;
                    this.version = res.data.data.version
                }
            })
        },
    },
    created() {
        this.getPlanById();
    }
}
</script>

<style scoped lang="less">
.planningReport {
    .titleBox {
        overflow: hidden;
        .title{
            font-size: 32px;
            font-weight: bolder;
            line-height: 80px;
            text-align: center;
            color:#0094EA;
            float: left;
        }
    }
    .mainBox {
        margin-bottom: 40px;
    }
    .content {
        padding: 30px;
        background-color: #fff;
    }
}
</style>